// extracted by mini-css-extract-plugin
export default {"BoxCheckbox":"BoxCheckbox_BoxCheckbox__ttgVa","label":"BoxCheckbox_label__kK1Ts","visualCheckbox":"BoxCheckbox_visualCheckbox__FFfoD"};